var LEO = (function($) {
    return {
        lastScrollTop: 0,
        windowWidth: $(window).width(),
        windowHeight: $(window).height(),
        homeMasonryGridContainer: $('#mosaic .item-container'),
        $grid: '',
        lastUpdatedPosition: null,
        homeScrollFlag: true,
        pageScrollAmount: 0,
        windowLoadedFlag: false,
        leoLoading: true,

        // Initial function
        init: function() {
            // Define the parent selector this variable
            var _this = this;
            _this.bindEvents();
            _this.windowEvents();
            //_this.resizeVideo();
            _this.contentCeiling();
            _this.msieversion();

            _this.videoPlay();
            _this.videoPlayCasestudy();
            _this.homeContentScroll();
            _this.aboutHeight();
            _this.inactivityScroll();
            _this.initPlayer();

            if (_this.windowWidth >= 520) {
                _this.castParallax();
            }

            if (lb_script_vars.is_contact_page) {
                _this.initMap('map');
            }

            if (lb_script_vars.is_news_page || lb_script_vars.is_work_page) {
                _this.newsSearch();
                if (lb_script_vars.is_news_page) {
                    var hash_str = window.location.hash;
                    if(hash_str.length > 0){
                        newsidarr = hash_str.split('#');
                        slug_arr = newsidarr[1].split('_');
                        p_type = slug_arr[0];
                        p_slug = slug_arr[1];
                        if (newsidarr.length > 1) {
                            _this.goToParticularNews(p_slug, p_type);
                        }
                    }
                }
            }

            if (lb_script_vars.splash_enable) {
                $('#splashpopup').delay(5000).fadeOut(400, function() {
                    $('#fullpage').css({ 'opacity': '1' });
                });
            }



            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $('body').addClass('device');
            } else {
                $('body').addClass('desktop');
            }
        },
        bindEvents: function() {
            var _this = this;
            _this.peopeHover();

            if (lb_script_vars.splash_enable) {
                $('#splashpopup img').on('click', function(e) {
                    $('#splashpopup').hide();
                    $('#fullpage').css({ 'opacity': '1' });
                    _this.inactivityScroll('splash');

                });
            }

            $('.leo-video').on('click', function(e) {
                LeoVideoPopup($(this).attr("href"));
                e.preventDefault();
            });

            var top = "";
            $('.mobile-nav-icon').click(function() {
                if (!$('html').hasClass('mobile-menu-slide')) {
                    $('.mobile-nav-icon').addClass('icon-transform');
                    top = $(window).scrollTop();
                    $('html').addClass('mobile-menu-slide');

                    if ($('.page-template-page-home').length) {
                        $('footer.footer').hide();
                    }
                } else {
                    if (_this.windowWidth <= 767) {
                        $('html, body').animate({
                            scrollTop: top
                        }, 10, function() {
                            $('html').removeClass('mobile-menu-slide');
                            $('.mobile-nav-icon').removeClass('icon-transform');
                        });
                    } else {
                        $('html').removeClass('mobile-menu-slide');
                        $('.mobile-nav-icon').removeClass('icon-transform');
                    }

                    if ($('.page-template-page-home').length) {
                        $('footer.footer').removeAttr('style');
                    }
                }
            });

            // Escape key press for close the navigation
            $(document).keyup(function(e) {
                if (e.keyCode == 27) { // escape key maps to keycode `27`
                    $(".site-menu .fa-close").trigger('click');
                    if (lb_script_vars.splash_enable) {
                        $('#splashpopup').hide();
                        $('#fullpage').css({ 'opacity': '1' });
                        _this.inactivityScroll();
                    }
                }
            });

            if (lb_script_vars.is_work_page || lb_script_vars.is_people_page) {
                $(".work_cat_filter").click(function() {
                    if (jQuery(this).hasClass('selectedwrokcat')) {

                    } else {
                        jQuery('.work_cat_filter').each(function() {
                            jQuery(this).removeClass("selectedwrokcat");
                        });
                        jQuery(this).addClass("selectedwrokcat");
                        var term_id = jQuery(this).attr('data-wcid');
                        var p_type = jQuery(this).attr('data-type');
                        var currentpage = 1; // What page we are on.
                        var ppp = -1; // Post per page
                        var currpageitems = 0;
                        var tax = '';
                        if (p_type == 'people') {
                            tax = 'people_cat';
                        } else {
                            tax = 'work_cat';
                        }
                        var lasttextblockbgcolor = 0;

                        if (term_id) {
                            $('.contentLoader').show();
                            $('#item-container').css('visibility', 'hidden');
                            _this.getFilteredItems(term_id, '', p_type, tax, currentpage, ppp, currpageitems, lasttextblockbgcolor);
                        } else {
                            _this.getFilteredItems('', '', p_type, tax, currentpage, ppp, currpageitems, lasttextblockbgcolor);
                        }
                    }
                });


            }

            if (lb_script_vars.is_news_page || lb_script_vars.is_work_page || lb_script_vars.is_people_page || lb_script_vars.is_casestudy_page) {
                //-----Load more posts on news or work page ------
                if (!lb_script_vars.is_news_page) {
                    $(window).scroll(function() {
                        var footerHeight = $('footer').outerHeight();
                       /* if ($(window).scrollTop() + $(window).height() >= ($(document).height() - footerHeight)) {
                            if (!$("#lb_load_more").hasClass('no-more-posts') && _this.leoLoading === true) {
                                $("#lb_load_more").click();
                            }
                        } */
                    });

                    // $(window).on('wheel', function(event) {
                    //     var evt = event.originalEvent || event;
                    //     if(evt.deltaY > 0 ) $("#lb_load_more").click();
                    // })
                }
                $("#lb_load_more").click(function() {

                    _this.leoLoading = false;
                    var currentpage = $('#lb_load_more').attr("data-currentpage"); // What page we are on.
                    var ppp = lb_script_vars.lb_ppp; // Post per page
                    var total_news = $('#item-container').attr("data-totalpost");
                    var currpageitems = $('#lb_load_more').attr("data-currentpageitems");
                    var term_id = $('#lb_load_more').attr("data-termid");
                    var p_type = $('#lb_load_more').attr("data-type");
                    var tax = $('#lb_load_more').attr("data-tax");
                    var lasttextblockbgcolor = $('#lb_load_more').attr("data-textblockbgcolor");
                    var seletec_wc_term_id = '';

                    if (lb_script_vars.is_people_page) {
                        // Calculate post per page for people section (so that we always have complete rows of people)
                        var contentWidth = $('.fixed-content').width();
                        var columnWidth = $('.grid-sizer').width();
                        var columnCount = Math.floor(contentWidth / columnWidth);
                        if (columnCount >= 4) {
                            // The default of 12 is fine for when we have 1,2,3 or 4 columns as 12 is cleanly divisible by these values
                            // Stewart - I have had to hard code this amount - basically because now we never know how a mnay columns we might have
                            // so perhaps this whole thing needs re-writing

                            ppp = lb_script_vars.lb_ppp;
                        } else if (columnCount > 3) {
                            ppp = columnCount * 2;
                        }
                    }

                    jQuery('.work_cat_filter').each(function() {
                        if (jQuery(this).hasClass("selectedwrokcat")) {
                            seletec_wc_term_id = jQuery(this).attr('data-wcid');
                        }
                    });

                    if ((currentpage * ppp) <= total_news) {
                        _this.get_newsorwork_list(term_id, seletec_wc_term_id, p_type, tax, currentpage, ppp, currpageitems, lasttextblockbgcolor);
                    } else {
                        $('#lb_load_more').addClass('no-more-posts');
                    }
                });
            } else if (lb_script_vars.is_home_page2) {
                $(window).scroll(function() {
                    var footerHeight = $('footer').outerHeight();
                    if ($(window).scrollTop() + $(window).height() >= ($(document).height() - footerHeight)) {
                        if (!$("#lb_load_more").hasClass('no-more-posts') && _this.leoLoading === true) {
                            $("#lb_load_more").click();
                        }
                    }
                });
                $("#lb_load_more").click(function() {
                    _this.leoLoading = false;
                    $(".lb-loading").show();
                    $("#lb_load_more").hide();
                    var total_posts = $('#lb_load_more').attr('data-totalposts');
                    var nextposts = $('#lb_load_more').attr('data-nextposts');
                    var ppp = $('#lb_load_more').attr('data-ppp');
                    if (nextposts) {
                        _this.get_hompagenew_list(total_posts, nextposts, ppp);
                    }
                });
            } else if (lb_script_vars.is_search) {
                $(window).scroll(function() {
                    var footerHeight = $('footer').outerHeight();
                    if ($(window).scrollTop() + $(window).height() >= ($(document).height() - footerHeight)) {
                        if (!$("#lb_load_more").hasClass('no-more-posts') && _this.leoLoading === true) {
                            $("#lb_load_more").click();
                        }
                    }
                });
                $("#lb_load_more").click(function() {
                    _this.leoLoading = false;
                    var next_posts = $('#lb_load_more').attr('data-nextpageposts');
                    var textblockbgcolor = $('#lb_load_more').attr('data-textblockbgcolor');
                    if (next_posts) {
                        _this.get_nextserached_posts(next_posts, textblockbgcolor);
                    }
                });
            } else {
                //-----Load more posts on home page ------

                $(window).scroll(function() {
                    var footerHeight = $('footer').outerHeight();
                    if ($(window).scrollTop() + $(window).height() >= ($(document).height() - footerHeight)) {
                        if (!$("#lb_load_more").hasClass('no-more-posts') && _this.leoLoading === true) {
                            $("#lb_load_more").click();
                        }
                    }
                });
                $("#lb_load_more").click(function() {
                    //console.log('HOME PAGE CLICK');

                    _this.leoLoading = false;
                    var currentpage = $('#lb_load_more').attr("data-currentpage"); // What page we are on.
                    var ppp = lb_script_vars.lb_ppp; // Post per page
                    var total_posts = $('.item-container').attr("data-totalitems");
                    var currpageitems = $('#lb_load_more').attr("data-currentpageitems");
                    var currpageworkitems = $('#lb_load_more').attr("data-currentpageworkitems");

                    var usedasset = $('#lb_load_more').attr("data-usedasset");
                    var totalbrandassets = $('#lb_load_more').attr("data-totalbrandassets");
                    var lasttxtblockbgcolor = $('#lb_load_more').attr("data-textblockbgcolor");
                    var cpbrandasset = $('#lb_load_more').attr("data-cpbrandasset");
                    var usedtweets = $('#lb_load_more').attr("data-usedtweets");
                    if ((currentpage * ppp) <= total_posts) {
                        _this.get_posts_list(currentpage, ppp, total_posts, currpageitems, usedasset, totalbrandassets, cpbrandasset, lasttxtblockbgcolor, usedtweets, currpageworkitems);
                    } else {
                        $('#lb_load_more').addClass('no-more-posts');
                    }
                });
            }

            $('.search-box').on('click', '.search-label li', function() {
                var term_id = $(this).attr('data-termid');
                var term_name = $(this).attr('data-termname');
                var tax = $(this).attr('data-tax');
                var seletec_wc_term_id = '';
                jQuery('.work_cat_filter').each(function() {
                    if (jQuery(this).hasClass("selectedwrokcat")) {
                        seletec_wc_term_id = jQuery(this).attr('data-wcid');
                    }
                });

                $('#term_id').val(term_id);
                $('#search_term').val(term_name);
                $('#taxonomy').val(tax);
                var p_type = $('#p_type').val();
                $('#res_autosuggest').hide();

                var currentpage = 1; // What page we are on.
                var ppp = lb_script_vars.lb_ppp; // Post per page
                var currpageitems = 0;

                if (term_id) {
                    $('.contentLoader').show();
                    $('#item-container').css('visibility', 'hidden');
                    _this.getFilteredItems(term_id, seletec_wc_term_id, p_type, tax, currentpage, ppp, currpageitems);
                }
                $("#search_term").removeAttr('style');
            });

            $('.search-box').on('click', '#search_img', function() {
                var term_name = $('#search_term').val();
                var term_id = $('#term_id').val();
                if (term_name === '' && term_id !== '') {
                    $('#term_id').val('');
                    $('#taxonomy').val('');
                    $('.contentLoader').show();
                    $('#item-container').css('visibility', 'hidden');
                    var seletec_wc_term_id = '';
                    jQuery('.work_cat_filter').each(function() {
                        if (jQuery(this).hasClass("selectedwrokcat")) {
                            seletec_wc_term_id = jQuery(this).attr('data-wcid');
                        }
                    });
                    var p_type = $('#p_type').val();
                    var currentpage = 1; // What page we are on.
                    var ppp = lb_script_vars.lb_ppp; // Post per page
                    var currpageitems = 0;
                    term_id = '';
                    var tax = '';
                    _this.getFilteredItems(term_id, seletec_wc_term_id, p_type, tax, currentpage, ppp, currpageitems);
                    $(this).hide();
                    $('#search_img').show();
                }

            });

            $('#close_img').click(function() {

                $('#search_term').val('');
                $('#res_autosuggest').val('');
                $('#res_autosuggest').hide('');
                $('.contentLoader').hide();
                var term_id = $('#term_id').val();
                if (term_id !== '') {
                    $('#item-container').css('visibility', 'hidden');
                    $('.contentLoader').show();
                    $('#term_id').val('');
                    var p_type = $('#p_type').val();
                    var currentpage = 1; // What page we are on.
                    var ppp = lb_script_vars.lb_ppp; // Post per page
                    var currpageitems = 0;
                    term_id = '';
                    var tax = '';
                    var seletec_wc_term_id = '';
                    jQuery('.work_cat_filter').each(function() {
                        if (jQuery(this).hasClass("selectedwrokcat")) {
                            seletec_wc_term_id = jQuery(this).attr('data-wcid');
                        }
                    });

                    _this.getFilteredItems(term_id, seletec_wc_term_id, p_type, tax, currentpage, ppp, currpageitems);
                }
                $(this).hide();
                $('#search_img').show();
            });
            $("#search_term").focus(function() {
                if (_this.windowWidth < 768) {
                    $(this).parents('.search-box').css('width', '100%');
                    $("h2.title").animate({
                        opacity: 0,
                    }, 100, function() {
                        // Animation complete.
                    });
                } else if (_this.windowWidth < 1024) {
                    $(this).css('width', '300px');
                } else if (_this.windowWidth < 1230) {
                    $(this).css('width', '592px');
                } else {
                    $(this).css('width', '594px');
                }
            });
            $("#search_term").blur(function() {
                if (_this.windowWidth < 768) {
                    $(this).parents('.search-box').removeAttr('style');
                    $("h2.title").animate({
                        opacity: 1,
                    }, 100, function() {
                        // Animation complete.
                    });
                }
                if ($('#res_autosuggest > li').length && ($('#res_autosuggest').css('display') == 'block')) {} else {
                    $(this).removeAttr('style');
                }
            });
        },
        windowEvents: function() {
            var _this = this;

            $(window).ready(function() {
                if ($('.load-video').length) {
                    setTimeout(function() {
                        $('.youtube-wrapper').css('opacity', '1');
                    }, 300);
                }

                _this.homeMasonryGridContainer.imagesLoaded().done(function() {

                    if (!lb_script_vars.is_work_page && !lb_script_vars.is_casestudy_page && !lb_script_vars.is_people_page && !lb_script_vars.is_news_page) {

                        // Move the final half height item to the end or add a filler

                        var $grid = $(_this.homeMasonryGridContainer);

                        var $lastHalfHeightItem = $grid.children('.one-half').last();

                        if ($lastHalfHeightItem.length === 1) {

                            $lastHalfHeightItem.appendTo($grid);

                        } else {

                            if (!$('body').hasClass('blog')) {
                                _this.getFillerEl().appendTo($grid);
                            }

                        }

                    }

                    // Initialise packery

                    _this.$grid = _this.homeMasonryGridContainer.packery({
                        itemSelector: '.tile',
                        columnWidth: '.grid-sizer',
                        gutter: '.gutter-sizer',
                        percentPosition: false,
                        transitionDuration: 0
                    });

                    // This class causes the tiles to animate in
                    _this.$grid.children().addClass('is-loaded');

                });

                if ($('.page-template-page-home').length) {
                    var deleteLog = false;

                    if (_this.windowWidth >= 768) {
                        _this.homeHeaderAnimation();
                    } else {
                        _this.homeHeaderAnimation();
                    }
                }
            });
            $(window).resize(function() {

                var gutr = $('.home-masonary ul li.gutter-sizer').width();
                // $('.home-masonary ul li').css({'margin-bottom': gutr + 'px' });
                if ($(window).width() != _this.windowWidth) {
                    if ($('#mosaic').length) {
                        _this.masonryReload();
                    }
                }
                _this.windowWidth = $(window).width();
                _this.windowHeight = $(window).height();
                _this.contentCeiling();
                _this.aboutHeight();

                if ($('.page-template-page-home').length) {
                    $('header.header .content > .container').css('min-height', window.innerHeight, 'px');
                } else {
                    $('header.header .content > .container').removeAttr('style');
                }
            });
            $(window).scroll(function(event) {
                _this.contentCeiling();
                _this.fixHeader();

                if ($('.page-template-page-home').length) {
                    _this.homeHeaderAnimation();
                }
            });
            $(window).unbind('mousewheel DOMMouseScroll').bind('mousewheel DOMMouseScroll', function(event) {
                // if($('.page-template-page-home').length && !$('body').hasClass('device')) {
                //     _this.calculateScrollHomeAnimation('desktop', event);
                // }
            });
            $(window).on('orientationchange', function(event) {
                if ($('.page-template-page-home').length) {
                    _this.homeHeaderAnimation();
                }
            });
        },

        homeHeaderAnimation: function(currentSlide) {
            var _this = this;

            var scrollTop = $(window).scrollTop();
            var height = _this.windowHeight;

            if ($('.page-template-page-home').length) {
                $('header.header .content > .container').css('min-height', window.innerHeight, 'px');
            } else {
                $('header.header .content > .container').removeAttr('style');
            }

            var fixTop = $('main.content').offset().top - 98;
            if (_this.windowWidth < 768) {
                fixTop = $('main.content').offset().top - 60;
            }

            // Disabled dynamic header behavior on scroll, now permanently fixed (header.php).
            /*if (($(window).scrollTop() > fixTop) || (currentSlide > 0)) {
                $('header.header').addClass('homeFixHeader');
                $('nav').removeClass('black-nav');
                $('nav').show();
            } else {
                $('nav').addClass('black-nav');
                //$('header.header').removeClass('homeFixHeader');
            }*/

            _this.lastScrollTop = scrollTop;
            _this.homeContentScroll();
        },

        fixHeader: function() {
            var _this = this;
            var scrollTop = $(window).scrollTop();

            if (scrollTop !== 0 && !$('body').hasClass('page-template-page-home')) {
                $('header.header').addClass('fix');
            } else {
                $('header.header').removeClass('fix');
            }
        },
        masonryReload: function() {
            var _this = this;
            $('.image-block').css("height", '');

            _this.homeMasonryGridContainer.imagesLoaded().done(function() {
                _this.initializeMasonry();
                _this.$grid.children().addClass('is-loaded');
            });
        },
        initializeMasonry: function() {
            var _this = this;
            _this.homeMasonryGridContainer.packery('destroy');
            _this.homeMasonryGridContainer.packery({
                itemSelector: ".tile",
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                percentPosition: true,
                transitionDuration: 0
            });

        },
        packeryAppend: function($existingItems, newItems) {

            // Find the last half height item in the list
            var lastHalfHeightIndex = -1;
            for (var i = 0; i < newItems.length; i++) {

                if ($(newItems[i]).hasClass('one-half')) {
                    lastHalfHeightIndex = i;
                }

            }

            if (lastHalfHeightIndex > -1) {

                newItems.push(newItems.splice(lastHalfHeightIndex, 1)[0]);

            } else {

                newItems.push(this.getFillerEl().get(0));

            }

            // Add the new items
            $existingItems.append(newItems).packery('appended', newItems);


        },
        getFillerEl: function() {

           /* var currentTheme = lb_script_vars.current_theme || false;

            var theme = false; */
            /* if (currentTheme) {
                while (!theme) {
                    var rTheme = lb_script_vars.bg_color_arr[Math.floor(Math.random() * lb_script_vars.bg_color_arr.length)];
                    if (rTheme !== currentTheme) {
                        theme = rTheme;
                    }
                }
            } else {
                theme = 'green_spearmint';
            } */



            return $('');

        },
        contentCeiling: function() {
            var _this = this;
            var contentTop = '';

            if ($('.carousel-wrapper').length) {
                if (_this.windowWidth >= 768) {
                    if (!$('body.home').length) {
                        contentTop = parseInt($('main.content').offset().top);
                        if ((contentTop - $(window).scrollTop()) < 250) {
                            $('.carousel-wrapper').addClass('padding-eighty');
                        } else {
                            $('.carousel-wrapper').removeClass('padding-eighty');
                        }
                    }
                }
            }
        },
        get_posts_list: function(currentpage, ppp, total_posts, currpageitems, usedasset, totalbrandassets, cpbrandasset, lasttxtblockbgcolor, usedtweets, currpageworkitems) {
            var _this = this;
            loading = true;
            $.ajax({
                type: 'post',
                dataType: 'json',
                url: lb_script_vars.ajax_url,
                data: {
                    action: 'more_post_ajax',
                    offset: (currentpage * ppp),
                    ppp: ppp,
                    currentpage: currentpage,
                    currpageitems: currpageitems,
                    currpageworkitems: currpageworkitems,
                    usedasset: usedasset,
                    totalbrandassets: totalbrandassets,
                    cpbrandasset: cpbrandasset,
                    lasttxtblockbgcolor: lasttxtblockbgcolor,
                    /*bg_color_arr: lb_script_vars.bg_color_arr */
                    usedtweets: usedtweets
                },
                beforeSend: function() {
                    $(".lb-loading").show();
                    $("#lb_load_more").hide();
                },
                success: function(res) {
                    $(".lb-loading").hide();

                    var $items = $(res.elements);
                    _this.$grid.imagesLoaded().done(function() {

                        _this.packeryAppend(_this.$grid, $items);

                        _this.$grid.children().addClass('is-loaded');
                        _this.peopeHover();

                    });

                    $("#lb_load_more").attr("data-currentpageitems", res.currpage_items);
                    if (res.next_page > 0) {
                        $("#lb_load_more").attr("data-currentpage", res.next_page);
                        $("#lb_load_more").attr("data-textblockbgcolor", res.lasttxtblockbgcolor);
                        $("#lb_load_more").attr("data-usedtweets", res.next_tweet);
                        $("#lb_load_more").attr("data-currentpageworkitems", res.currentpageworkitems);

                        $("#lb_load_more").show();
                        _this.leoLoading = true;
                    } else {
                        $('#lb_load_more').addClass('no-more-posts');
                        _this.leoLoading = false;
                    }
                }
            });
        },
        get_hompagenew_list: function(total_posts, nextposts, ppp) {
            var _this = this;
            loading = true;

            $.ajax({
                type: 'post',
                dataType: 'json',
                url: lb_script_vars.ajax_url,
                data: {
                    action: 'homepagenew_more_post_ajax',
                    ppp: ppp,
                    total_posts: total_posts,
                    nextposts: nextposts
                },
                beforeSend: function() {
                    $(".lb-loading").show();
                    $("#lb_load_more").hide();
                },
                success: function(res) {
                    $(".lb-loading").hide();
                    if (res.nextposts) {
                        $("#lb_load_more").attr("data-nextposts", res.nextposts);
                        $("#lb_load_more").show();
                        _this.leoLoading = true;
                    } else {
                        $('#lb_load_more').addClass('no-more-posts');
                        _this.leoLoading = false;
                    }
                    var $items = $(res.elements);
                    _this.$grid.imagesLoaded().done(function() {
                        _this.$grid.append($items).packery('appended', $items);
                        // setTimeout(function(){
                        _this.$grid.packery('reloadItems');
                        _this.$grid.packery('layout');
                        _this.$grid.one('layoutComplete', function() {

                            _this.$grid.packery('reloadItems');
                        });
                        _this.$grid.children().addClass('is-loaded');
                        _this.peopeHover();
                        // },300);

                    });
                }
            });

        },
        get_nextserached_posts: function(next_posts) {
            var _this = this;
            loading = true;
            $.ajax({
                type: 'post',
                dataType: 'json',
                url: lb_script_vars.ajax_url,
                data: {
                    action: 'more_nextserached_posts',
                    nextposts: next_posts,
                    /* lasttextblockbgcolor: textblockbgcolor */
                    /* bg_color_arr: lb_script_vars.bg_color_arr */
                },
                beforeSend: function() {
                    $(".lb-loading").show();
                    $("#lb_load_more").hide();
                },
                success: function(res) {
                    $(".lb-loading").hide();

                    if (res.next_page) {
                        $("#lb_load_more").attr("data-nextpageposts", res.next_page);
                        $("#lb_load_more").attr("data-textblockbgcolor");
                        $("#lb_load_more").show();
                        _this.leoLoading = true;
                    } else {
                        $('#lb_load_more').addClass('no-more-posts');
                        _this.leoLoading = false;
                    }

                    $(_this.homeMasonryGridContainer).append(res.elements);
                    $(_this.homeMasonryGridContainer).imagesLoaded().progress(function() {
                        $(_this.homeMasonryGridContainer).packery('reloadItems');
                        $(_this.homeMasonryGridContainer).packery('layout');
                        $(_this.homeMasonryGridContainer).children().addClass('is-loaded');
                    });
                }

            });
        },
        get_newsorwork_list: function(term_id, seletec_wc_term_id, p_type, tax, currentpage, ppp, currpageitems) {
            var _this = this;
            loading = true;
            $.ajax({
                type: 'post',
                dataType: 'json',
                url: lb_script_vars.ajax_url,
                data: {
                    action: 'more_newsorwork_ajax',
                    post_type: p_type,
                    term_id: term_id,
                    seletec_wc_term_id: seletec_wc_term_id,
                    tax: tax,
                    offset: (currentpage * ppp),
                    ppp: ppp,
                    currentpage: currentpage,
                    currpageitems: currpageitems
                },
                beforeSend: function() {
                    $(".lb-loading").show();
                    $("#lb_load_more").hide();
                },
                success: function(res) {
                    $(".lb-loading").hide();
                    $("#lb_load_more").attr("data-currentpageitems", res.currpage_items);
                    $("#lb_load_more").attr("data-type", p_type);
                    $("#lb_load_more").attr("data-termid", term_id);
                    $("#lb_load_more").attr("data-tax", tax);

                    if (res.next_page > 0) {
                        $("#lb_load_more").attr("data-currentpage", res.next_page);
                        $("#lb_load_more").attr("data-textblockbgcolor");
                        $("#lb_load_more").show();
                        _this.leoLoading = true;
                    } else {
                        $('#lb_load_more').addClass('no-more-posts');
                        _this.leoLoading = false;
                    }

                    if (p_type === 'work' || p_type === 'case_study' || p_type === 'people') {

                        $(_this.homeMasonryGridContainer).append(res.elements);

                        $(_this.homeMasonryGridContainer).imagesLoaded().progress(function() {
                            $(_this.homeMasonryGridContainer).packery('reloadItems');
                            $(_this.homeMasonryGridContainer).packery('layout');
                            $(_this.homeMasonryGridContainer).children().addClass('is-loaded');
                        });

                        _this.peopeHover();

                    } else {
                        $('#item-container').append(res.elements);
                    }
                }
            });
        },
        resizeVideo: function() {

            var _this = this;
            var intViewportHeight = window.innerHeight;
            var detail_section = $(".detail-section").width();
            var removed_height = $(".page-title").outerHeight(true) + $(".header").outerHeight(true);
            var vwidth = ((intViewportHeight - removed_height) * 16 / 9);

            if ($('.video-item iframe').length) {
                if (vwidth <= detail_section) {
                    $('.video-item iframe, .video-poster-image.yt-poster').css('height', (intViewportHeight - removed_height), 'px');
                    $('.video-item iframe, .video-poster-image.yt-poster').css('width', vwidth, 'px');
                } else {
                    var videowidth = detail_section;
                    var videoheight = (videowidth);
                    $('.video-item iframe, .video-poster-image.yt-poster').css('height', videoheight, 'px');
                    $('.video-item iframe, .video-poster-image.yt-poster').css('width', videowidth, 'px');
                }
            }
            if ($('.carousel-wrapper ul li iframe').length) {
                if (vwidth <= detail_section) {
                    $('.carousel-wrapper ul li iframe, .video-poster-image.yt-poster').css('height', (intViewportHeight - removed_height), 'px');
                    $('.carousel-wrapper ul li iframe, .video-poster-image.yt-poster').css('width', vwidth, 'px');
                    $('.carousel-wrapper ul li').css('margin', '0 auto');
                } else {
                    var videoWidth = detail_section;
                    var videoHeight = (videoWidth / 16) * 9;
                    $('.carousel-wrapper ul li iframe, .video-poster-image.yt-poster').css('height', videoHeight, 'px');
                    $('.carousel-wrapper ul li iframe, .video-poster-image.yt-poster').css('width', videoWidth, 'px');
                }
            }
        },
        initMap: function(map_id) {
            var map_center = { lat: Number(lb_script_vars.lat), lng: Number(lb_script_vars.lng) };
            var map = new google.maps.Map(document.getElementById(map_id), {
                zoom: 16,
                mapTypeControl: false,
                draggable: true,
                scaleControl: false,
                scrollwheel: true,
                navigationControl: false,
                streetViewControl: false,
                disableDefaultUI: true,
                center: map_center,
                clickableIcons: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
            });

            map.setOptions({ disableDoubleClickZoom: true });

            var marker = new google.maps.Marker({
                position: map_center,
                map: map,
                title: lb_script_vars.site_title + ' Group'
            });

            google.maps.event.addDomListener(window, "resize", function() {
                var center = map.getCenter();
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
            });

        },
        videoPlay: function() {
            var _this = this;
            if ($('.carousel-wrapper iframe.yt-iframe').length) {
                $('.video-section .yt-poster').on('click', function() {
                    $(".yt-video .play").click();
                });

                $('.yt-video .play').on('click', function() {
                    carousel.clearInterval();
                    setTimeout(function() {
                        $('.youtube-wrapper').removeClass('load-video');
                    }, 500);
                    $(' .carousel-wrapper .container .yt-video .pause').fadeIn();
                    $(this).parents('li').find('.yt-poster, .container .yt-video .play').fadeOut();
                    $('.carousel-nubbins').css('visibility', 'hidden');
                    //carousel.interVal1();
                });

                $('.yt-video .pause').on('click', function() {
                    carousel.clearInterval();
                    $(' .carousel-wrapper .container .yt-video .play').fadeIn();
                    $('.carousel-wrapper .container .yt-video .pause').fadeOut();

                    $(this).parents('li').find('.container .yt-video .pause').fadeOut();
                    //$(this).parents('li').find('.yt-poster').fadeIn();
                    $(this).parents('li').find(' .container .yt-video .play').fadeIn();
                    $('.carousel-nubbins').css('visibility', 'visible');
                    carousel.interVal1();
                });
            }
        },
        videoPlayCasestudy: function() {
            var _this = this;
            if ($('.video-item iframe.yt-iframe').length) {
                $('.video-item .yt-poster').on('click', function() {
                    $(this).parents('.video-item').find('.yt-video .play').click();
                });

                $('.yt-video .play').on('click', function() {
                    $(this).parents('.video-item').find('.yt-video .pause').fadeIn();
                    $(this).parents('.video-item').find('.yt-poster, .yt-video .play').fadeOut();
                });
                $('.yt-video .pause').on('click', function() {
                    $(this).parents('.video-item').find('.yt-video .play').fadeIn();
                    $(this).parents('.video-item').find('.yt-video .pause').fadeOut();

                    $(this).parents('.video-item').find('.yt-video .pause').fadeOut();
                    $(this).parents('.video-item').find('.yt-video .play').fadeIn();
                });
            }
        },
        newsSearch: function() {
            $("#search_term").keyup(function() {
                var search_term = $('#search_term').val().trim();
                var post_type = $('#p_type').val().trim();

                if ($(this).val()) {
                    $('#search_img').hide();
                    $('#close_img').show();
                } else {
                    $('#search_img').show();
                    $('#close_img').hide();
                }

                if (search_term.length >= 3) {
                    $.ajax({
                        type: 'post',
                        url: lb_script_vars.ajax_url,
                        data: {
                            action: 'search_tag_catgories_ajax',
                            post_type: post_type,
                            search_term: search_term
                        },
                        beforeSend: function() {},
                        success: function(res) {
                            $('#res_autosuggest').show();
                            $('#res_autosuggest').html(res);
                        }
                    });
                } else {
                    $('#res_autosuggest').html('');
                }
            });
        },
        getFilteredItems: function(term_id, seletec_wc_term_id, p_type, tax, currentpage, ppp, currpageitems, lasttextblockbgcolor) {
            var _this = this;
            $.ajax({
                type: 'post',
                dataType: 'json',
                url: lb_script_vars.ajax_url,
                data: {
                    action: 'get_filtered_items',
                    post_type: p_type,
                    term_id: term_id,
                    seletec_wc_term_id: seletec_wc_term_id,
                    tax: tax,
                    offset: (currentpage * ppp),
                    ppp: ppp,
                    currentpage: currentpage,
                    currpageitems: currpageitems
                },
                beforeSend: function() {
                    $("#loader_ul").show();
                    $("#lb_load_more").hide();
                },
                success: function(res) {
                    $("#loader_ul").hide();
                    $('#item-container').html('');

                    if (p_type == 'work' || p_type == "people") {
                        if (res.elements !== '') {
                            $('#item-container').html('<li class="grid-sizer"></li><li class="gutter-sizer"></li>');
                            $('#item-container').show();
                            $('#no-record').hide();
                            $(_this.homeMasonryGridContainer).append(res.elements);
                            $("#lb_load_more").attr("data-textblockbgcolor");

                            $(_this.homeMasonryGridContainer).imagesLoaded().progress(function() {
                                $(_this.homeMasonryGridContainer).packery('reloadItems');
                                $(_this.homeMasonryGridContainer).packery('layout');
                                $(_this.homeMasonryGridContainer).children().addClass('is-loaded');
                            });
                            $('#lb_load_more').removeClass('no-more-posts');
                            _this.leoLoading = true;
                            _this.peopeHover();

                        } else {
                            $('#item-container').hide();
                            $('#no-record').show();
                        }
                    } else {
                        if (res.elements !== '') {
                            $('#item-container').show();
                            $('#no-record').hide();
                            $('#item-container').append(res.elements);
                        } else {
                            $('#item-container').hide();
                            $('#no-record').show();
                        }
                    }
                    $('#item-container').attr('data-totalpost', res.total_filtered_post);
                    $('.contentLoader').hide();
                    $('#item-container').css('visibility', 'visible');

                    if (res.next_page > 0) {
                        $("#lb_load_more").attr("data-currentpage", res.next_page);
                        $("#lb_load_more").attr("data-currentpageitems", res.currpage_items);

                        $("#lb_load_more").attr("data-type", p_type);
                        $("#lb_load_more").attr("data-termid", term_id);
                        $("#lb_load_more").attr("data-tax", tax);
                        $("#lb_load_more").show();
                    }

                }
            });
        },
        msieversion: function() {
            var _this = this;

            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
            {
                $('body').addClass('ie');
            } else // If another browser, return 0
            {
                $('body').removeClass('ie');
            }

            return false;
        },
        homeContentScroll: function() {
            var _this = this;
            if (_this.windowWidth >= 768) {
                if ($('.home').length) {
                    var homeScroll = 100;
                    var contentTop = '';
                    if ($("body").hasClass("device")) {
                        homeScroll = 50;
                    } else {
                        homeScroll = 100;
                    }
                    contentTop = parseInt($('main.content').offset().top);

                    if ((contentTop - $(window).scrollTop()) < 350) {
                        // $('.carousel-wrapper').css('padding-bottom','80px');

                        if ($('header').hasClass('homeFixHeader')) {
                            $('.header-content-wrapper a').removeClass('logo-hide');
                        } else {
                            $('.header-content-wrapper a').addClass('logo-hide');
                        }

                    } else {
                        $('.carousel-wrapper').css('padding-bottom', '0px');
                        if ($('header').hasClass('homeFixHeader')) {
                            $('.header-content-wrapper a').removeClass('logo-hide');
                        } else {
                            $('.header-content-wrapper a').addClass('logo-hide');
                        }
                    }
                }
            }
        },
        peopeHover: function() {
            var _this = this;
            if (_this.windowWidth <= 1024) {
                $('.home-masonary li').unbind('click').bind('click', function(e) {
                    if ($(this).hasClass('work')) {
                        if ($(this).hasClass('tap')) {
                            $('.home-masonary li').removeClass('tap');
                            $(this).find('.work-details').css('opacity', 0);
                            return true;
                        } else {
                            $('.home-masonary li').removeClass('tap');
                            $('.home-masonary li.work').find('.work-details').css('opacity', 0);

                            $(this).addClass('tap');
                            $(this).find('.work-details').css('opacity', 1);
                            return false;
                        }
                    } else if ($(this).hasClass('twitter-block')) {
                        $('.home-masonary li.work').removeClass('tap');
                        $('.home-masonary li.work').find('.work-details').css('opacity', 0);
                        $('.home-masonary li.text-block').removeClass('tap');
                    } else {
                        if ($(this).hasClass('tap')) {
                            $('.home-masonary li.work').removeClass('tap');
                            $('.masonary li.work').find('.work-details').css('opacity', 0);
                            $('.home-masonary li.text-block').removeClass('tap');
                            return true;
                        } else {
                            $('.home-masonary li.work').removeClass('tap');
                            $('.home-masonary li.work').find('.work-details').css('opacity', 0);
                            $('.home-masonary li.text-block').removeClass('tap');

                            $(this).addClass('tap');
                            $(this).find('.category-detail-block').css('opacity', 1);
                            return false;
                        }
                    }

                });

                $('.masonary li.people').unbind('click').bind('click', function(e) {
                    if ($(this).hasClass('people')) {
                        e.preventDefault();
                        if ($(this).find('.people-details').hasClass('people-hover')) {
                            $('.masonary li.people').find('.people-details').removeClass('people-hover');
                            $(this).find('.people-details').css('opacity', 0);
                        } else {
                            $('.masonary li.people').find('.people-details').removeClass('people-hover');
                            $(this).find('.people-details').addClass('people-hover');
                            $(this).find('.people-details').css('opacity', 1);
                        }
                    }
                });
            }
        },
        aboutHeight: function() {
            var _this = this;

            if ($('.about-content').length) {
                if (_this.windowWidth >= 768) {
                    $('.heading-aside, .heading-table').removeAttr('style');

                    $('.about-content').each(function() {
                        var contentHeight = $(this).children('.content-aside').height();

                        $(this).children('.heading-aside').css('min-height', contentHeight + 'px');
                        $(this).find('.heading-table').css('height', contentHeight + 'px');
                    });
                } else if (_this.windowWidth < 768) {
                    $('.heading-aside, .heading-table').removeAttr('style');
                }
            }
        },
        inactivityScroll: function(splash) {
            var _this = this;
            var navHeight = 96;
            if (_this.windowWidth < 768) {
                navHeight = 58;
            } else {
                navHeight = 96;
            }
            if ($('body').hasClass('home')) {

                var act = false;
                if (typeof(splash) === undefined) {
                    $("body").click(function(e) {
                        act = true;
                    });
                } else {
                    act = false;
                }

                $(window).scroll(function() {
                    act = true;
                });
                setTimeout(function() {
                    if(!act){
                        if ($("body").scrollTop() < 1) {
                            //console.log("---if");
                            $("html, body").animate({ scrollTop: $("#section1").offset().top - navHeight }, 'slow');
                        }
                    }
                }, 4000);

            }
        },
        initPlayer: function() {
            const controls = [
                'play-large', // The large play button in the center
                'restart', // Restart playback
                'play', // Play/pause playback
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control
                'captions', // Toggle captions
                'pip', // Picture-in-picture (currently Safari only)
                'airplay', // Airplay (currently Safari only)
                'fullscreen' // Toggle fullscreen
            ];
            const player = Plyr.setup('#player-vimeo', { controls, fullscreen : { enabled: true, fallback: true, iosNative: true, container: null }});
        },
        castParallax: function() {
            window.addEventListener("scroll", function(event) {
                var top = this.pageYOffset;
                var layers = document.getElementsByClassName("parallax");
                var layer, speed, yPos;
                for (var i = 0; i < layers.length; i++) {
                    layer = layers[i];
                    speed = layer.getAttribute('data-speed');
                    yPos = (top * speed / 100);
                    Object.assign(layer.style.transform = 'translate3d(0px, ' + yPos + 'px, 0px)');
                }

                var layersInverse = document.getElementsByClassName("parallax-inversion");
                var inverseLayer, inverseSpeed, inverseYpos;
                for (var j = 0; j < layersInverse.length; j++) {
                    inverseLayer = layersInverse[j];
                    inverseSpeed = inverseLayer.getAttribute('data-speed');
                    inverseYpos = (top * inverseSpeed / 100);
                    inverseYpos = -Math.abs(inverseYpos);
                    Object.assign(inverseLayer.style.transform = 'translate3d(0px, ' + inverseYpos + 'px, 0px)');
                }

            });
        },
        goToParticularNews: function(pslug, ptype) {
            var _this = this;
            loading = true;
            $.ajax({
                type: 'post',
                dataType: 'json',
                url: lb_script_vars.ajax_url,
                data: {
                    action: 'goToParticularNews',
                    news_slug: pslug,
                    p_type: ptype
                },
                beforeSend: function() {},
                success: function(res) {
                    //$(".lb-loading").hide();
                    $("#lb_load_more").attr("data-currentpageitems", res.currpage_items);
                    $("#lb_load_more").attr("data-type", 'news');

                    if (res.next_page > 0) {
                        $("#lb_load_more").attr("data-currentpage", res.next_page);
                        $("#lb_load_more").show();
                    } else {
                        $("#lb_load_more").hide();
                    }
                    $('#item-container').html(res.elements);

                    setTimeout(function() {
                        if (_this.windowWidth <= 767) {
                            h_reduce = 85;
                        } else if (_this.windowWidth > 767 && _this.windowWidth < 1024) {
                            h_reduce = 115;
                        } else {
                            h_reduce = 142;
                        }
                        $('html, body').animate({
                            'scrollTop': $("#" + res.div_id).offset().top - h_reduce
                        }, 1500);
                    }, 1000);

                }
            });
        }
    };
})(jQuery);

//Document on load
jQuery(document).ready(function($) {
    // initialize the LEO function
    LEO.init();
});

jQuery(window).load(function($) {
    jQuery('header.banner .content .carousel-wrapper ul li iframe').css({ 'visibility': 'visible', 'opacity': 1 });
});

function onPlayerStateChange(event) {
    if (event.data === 2) {
        carousel.clearInterval();
        jQuery('header.banner .content .carousel-wrapper ul li iframe').css('transform', 'translate(-50%, -50%)');
        jQuery('.carousel-wrapper .container .yt-video .play').fadeIn();
        jQuery('.carousel-wrapper .container .yt-video .pause').fadeOut();

        jQuery(this).parents('li').find('.container .yt-video .pause').fadeOut();
        //jQuery('.video-poster-image.yt-poster').show();
        jQuery(this).parents('li').find('.container .yt-video .play').fadeIn();
        jQuery('.carousel-nubbins').css('visibility', 'visible');
        carousel.interVal1();
    }
    if (event.data === 1) {
        jQuery('header.banner .content .carousel-wrapper ul li iframe').css('transform', 'translate(-50%, -54%)');
        jQuery('.carousel-wrapper .container .yt-video .pause').fadeIn();
        jQuery(this).parents('li').find('.yt-poster').hide();
        jQuery('.carousel-wrapper .container .yt-video .play').fadeOut();
        jQuery('.carousel-nubbins').css('visibility', 'hidden');
        jQuery(this).parents('li').find('.yt-poster').hide();
    }
    if (event.data === 0) {
        carousel.clearInterval();

        jQuery('.carousel-wrapper .yt-poster, .carousel-wrapper .container .yt-video .play').fadeIn();
        jQuery('.carousel-wrapper .container .yt-video .pause').fadeOut();

        jQuery(this).parents('li').find('.container .yt-video .pause').fadeOut();
        jQuery(this).parents('li').find('.yt-poster').fadeIn();
        jQuery(this).parents('li').find('.container .yt-video .play').fadeIn();
        jQuery('.carousel-nubbins').css('visibility', 'visible');
        carousel.interVal1();
    }
}

function onPlayerStateChangeCasestudy(event) {
    if (event.data === 2) {
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .play').fadeIn();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .pause').fadeOut();

        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .pause').fadeOut();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-poster').show();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .play').fadeIn();
    }
    if (event.data === 1) {
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .pause').fadeIn();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-poster').hide();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .play').fadeOut();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-poster').hide();
    }
    if (event.data === 0) {
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .play').fadeIn();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .pause').fadeOut();

        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .pause').fadeOut();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-poster').fadeIn();
        jQuery('#' + event.target.a.id).parents('.video-item').find('.yt-video .play').fadeIn();
    }
}

function LeoVideoPopup(link) {
    var _this = this;
    if (link) {
        var split_c = "v=";
        var split_n = 1;
        var EmbedLink = "https://www.youtube.com/embed/" + cleanID + "?autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0";

        var videoLink = link;

        if (videoLink.match(/(youtube.com)/)) {
            split_c = "v=";
            split_n = 1;
        }

        var getVideoID = videoLink.split(split_c)[split_n];
        var cleanID = getVideoID.replace(/(&)+(.*)/, "");

        if (videoLink.match(/(youtu.be)/) || videoLink.match(/(youtube.com)/)) {
            EmbedLink = "https://www.youtube.com/embed/" + cleanID + "?autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0";
        }
        var vid_w = '';
        var vid_h = '';
        if (jQuery(window).width() >= 767) {
            vid_w = jQuery(window).width() * 0.8;
            vid_h = vid_w / (16 / 9);
        }

        jQuery("body").append('<div class="LeoPopUp-Wrap LeoPopUp-animation"><div class="LeoPopUp-Content"><span class="LeoPopUp-Close"></span><iframe width=" ' + vid_w + 'px" height=" ' + vid_h + 'px" src="' + EmbedLink + '" frameborder="0" allowfullscreen></iframe></div></div>');

        if (jQuery('.LeoPopUp-Wrap').hasClass('LeoPopUp-animation')) {
            jQuery('.LeoPopUp-Wrap').removeClass("LeoPopUp-animation");
        }

        jQuery(".LeoPopUp-Wrap, .LeoPopUp-Close").click(function() {
            jQuery(".LeoPopUp-Wrap").addClass("LeoPopUp-Hide").delay(515).queue(function() { jQuery(this).remove(); });
        });
    }

    jQuery(document).keyup(function(e) {
        if (e.keyCode == 27) {
            jQuery('.LeoPopUp-Wrap, .LeoPopUp-Close').click();
        }
    });


    jQuery(".play").click(function() {
        console.log('click', jQuery(this).data('player'));
        var videoRectangle = jQuery(this).data('player');
        var iframe = videoRectangle.childNodes[0];
        var player = $f(iframe);
        player.api("play");
    });

}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
